import { FunctionComponent } from 'react'

import TipoArticuloListado from './listado/TipoArticuloListado'

interface OwnProps {}

type Props = OwnProps

/**
 * Gestion o paginba principal para gestionar los almacen
 * @param props
 * @constructor
 */
const TipoArticuloGestion: FunctionComponent<Props> = (props) => {
  return <TipoArticuloListado />
}

export default TipoArticuloGestion
